import { Paths, PathValue } from "@mctypes/global.types";
import React from "react";
import { Box, Button, Flex, Text } from "@mantine/core";
import { HSpace } from "../../../../../../../components";
import { IGKLuftmengdemaalingResultater, IGKRapport } from "@mcapps/shared/reportSchemas/gkReportSchema";
import LuftventilAnemometer from "./LuftventilAnemometer";

const AnemometerTest: React.FC<{
  onUpdateEditData: <P extends Paths<IGKRapport, 4>>(path: P, value: PathValue<IGKRapport, P>) => void;
  data: IGKLuftmengdemaalingResultater;
}> = ({ data, onUpdateEditData }) => {
  const addNewRow = () => {
    const newMaaleresultaterArray = {
      ventilnummer: null,
      maaleomraadeAreal: null,
      andelFrittAreal: null,
      maaleresultater: [],
      beregninger: {
        minimumAntallRuterIRutenett: null,
        frittArealIHverRute: null,
        gjennomsnittligHastighet: null,
        totalLuftmengde: null,
      },
    };

    const updatedMaaleresultaterArray = [
      ...data.inndata.anemometerResultater.resultaterPerVentil,
      newMaaleresultaterArray,
    ];

    onUpdateEditData(
      "testResultater.luftmengdeMaalingIRom.inndata.anemometerResultater.resultaterPerVentil",
      updatedMaaleresultaterArray,
    );

    return updatedMaaleresultaterArray;
  };

  const removeLastRow = () => {
    const updatedMaaleresultaterArray = [...data.inndata.anemometerResultater.resultaterPerVentil];

    if (updatedMaaleresultaterArray.length > 0) {
      updatedMaaleresultaterArray.pop(); // Remove the last element
      onUpdateEditData(
        "testResultater.luftmengdeMaalingIRom.inndata.anemometerResultater.resultaterPerVentil",
        updatedMaaleresultaterArray,
      );
    }
  };

  const onUpdateVentilData = (updatedData?: any, ventilIndex?: number) => {
    const resultaterPerVentil = [...data.inndata.anemometerResultater.resultaterPerVentil];
    resultaterPerVentil[ventilIndex] = updatedData;

    const totalLuftmengde = resultaterPerVentil.reduce((acc, curr) => acc + curr.beregninger.totalLuftmengde, 0);

    const anemometerResultater = {
      ...data.inndata.anemometerResultater,
      resultaterPerVentil: resultaterPerVentil,
      totalLuftmengde: totalLuftmengde,
    };
    onUpdateEditData("testResultater.luftmengdeMaalingIRom.inndata.anemometerResultater", anemometerResultater);
    return totalLuftmengde;
  };

  return (
    <div>
      <h4>Anemometermåling</h4>
      <Box mt={0} mb="1.5rem">
        <Flex direction="column" mb="lg">
          <b>Legg til og trekk fra ventiler:</b>
          <Flex>
            <Button color="green" onClick={addNewRow}>
              Legg til ventil
            </Button>
            <HSpace />
            <Button
              variant="danger-filled"
              onClick={removeLastRow}
              disabled={data.inndata?.anemometerResultater?.resultaterPerVentil?.length < 1}
            >
              Fjern siste ventil
            </Button>
          </Flex>
        </Flex>
      </Box>
      {data.inndata.anemometerResultater.resultaterPerVentil != null &&
        data.inndata.anemometerResultater.resultaterPerVentil?.length > 0 && (
          <>
            {data.inndata.anemometerResultater.resultaterPerVentil.map((resultat, index) => (
              <Box key={index} mb="1.5rem">
                <b>Luftventil {index + 1}</b>
                <LuftventilAnemometer onUpdateVentilData={onUpdateVentilData} data={resultat} ventilIndex={index} />
              </Box>
            ))}
          </>
        )}
      <Flex justify="space-between" mt="0.5rem">
        <Text fw={700} mb={0}>
          Total luftmengde &#40;m<sup>3</sup>/s&#41; ={" "}
          <b>{data.inndata.anemometerResultater.totalLuftmengde?.toFixed(3)}</b>
        </Text>
        <Text mb={0}>Formel: &#40;Q = SUM&#40;Vn * Ac&#41;&#41;</Text>
      </Flex>
    </div>
  );
};

export default AnemometerTest;
